import { ArrowForwardIos } from '@interhyp/platform-icons';
import { animated, useSpring } from '@react-spring/web';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useMeasure } from 'react-use';
import { Card } from "../card/Card.js";
import { Typography } from "../typography/Typography.js";
import styles from "./Collapsible.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Collapsible({
  className,
  title,
  children,
  open,
  onOpen,
  shadow,
  uncontrolled,
  variant = 'solid',
  ...rest
}) {
  const [internalOpen, setInternalOpen] = useState(open);
  useEffect(() => {
    setInternalOpen(open);
  }, [open]);
  const [ref, {
    height
  }] = useMeasure();
  const expand = useSpring({
    height: internalOpen ? `${height}px` : '0px'
  });
  const spin = useSpring({
    config: {
      friction: 15
    },
    transform: internalOpen ? 'rotate(270deg)' : 'rotate(90deg)'
  });
  function handleClick() {
    if (uncontrolled) {
      setInternalOpen(!internalOpen);
    }
    onOpen?.();
  }
  return /*#__PURE__*/_jsxs(Card, {
    shadow: shadow,
    className: classnames(styles.collapsible, className, styles[variant]),
    ...rest,
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-expanded": internalOpen,
      tabIndex: 0,
      className: styles.header,
      onClick: handleClick,
      type: "button",
      children: [typeof title === 'string' ? /*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        margin: false,
        children: title
      }) : title, /*#__PURE__*/_jsx(animated.div, {
        style: spin,
        children: /*#__PURE__*/_jsx(ArrowForwardIos, {})
      })]
    }), /*#__PURE__*/_jsx(animated.div, {
      className: styles.wrapper,
      style: expand,
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        className: styles.content,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.padding,
          children: children
        })
      })
    })]
  });
}